import { EnvironmentProviders } from '@angular/core';
import { getActionTypeFromInstance, withNgxsPlugin } from '@ngxs/store';

import { Logout } from '@data/state';

function logoutPlugin(state: any, action: any, next: any) {
    if (getActionTypeFromInstance(action) === Logout.type) {
        state = {
            ...state,
            auth: {
                token: null,
                expiration: null,
                refreshToken: null,
                refreshTokenExpiration: null,
                userName: null,
                firstName: null,
                lastName: null,
                email: null,
            },
        };
    }
    return next(state, action);
}

export const provideStateLogoutPlugin = (): EnvironmentProviders => withNgxsPlugin(logoutPlugin);
